import { cancelExchangeOffers } from "../../../app/api/exchangeOffer";
import { BaseAction } from "../../../core/actions/BaseAction";

export interface IAutoCancelOngoingExchangePair {
    bookingId: string;
    exchangeOperationId: string;
}

export interface IAutoCancelOngoingExchangesParams {
    pairs: IAutoCancelOngoingExchangePair[];
}

class AutoCancelOngoingExchangesAction extends BaseAction<void, IAutoCancelOngoingExchangesParams> {
    override async run(): Promise<void> {
        const params = this.params;
        if (!params || params.pairs.length === 0) return;

        const results = await Promise.allSettled(
            params.pairs.map((pair) =>
                cancelExchangeOffers(pair.bookingId, pair.exchangeOperationId)
            )
        );

        results.forEach((r, i) => {
            if (r.status === "rejected") {
                console.error(
                    "AutoCancelOngoingExchanges: cancel failed",
                    params.pairs[i],
                    r.reason
                );
            }
        });
    }
}

export const autoCancelOngoingExchangesAction = new AutoCancelOngoingExchangesAction();
